/// <amd-module name="Build/Designer/Constants" />

export namespace EditorConstants {
    export const ElementToFocusOnEscape = "ci-editor-escape-focus-element";
    export const ToastDuration = 5000;
    export const YamlAssistantToggleElement = "yaml-assistant-toggle-element";
}

export namespace FwLinks {
    export const AzurePipelinesDocs = "https://go.microsoft.com/fwlink/?linkid=2024748";
    export const LearnMoreVariables = "https://go.microsoft.com/fwlink/?linkid=2098718";
}

export namespace LegacyDesignerTabKeys {
    export const Triggers = "Tab_Triggers";
    export const Variables = "Tab_Variables";
    export const Yaml = "Tab_Tasks";
}

export namespace TemplateConstants {
    export const TemplateIdKey = "templateid";
    export const RepositoryNameKey = "repositoryName";
    export const K8sConnectionKey = "k8sConnection";
    export const SubscriptionId = "subscriptionId";
}

export namespace TemplateRequiredConstants {
    export const AzureSubscription = "connectedService:azureRM";
    export const DataSourcePicklist = "dataSourcePicklist";
    export const KubernetesEndpoint = "endpoint:kubernetes";
}

export namespace TemplateParameterTypes {
    export const AzureContainerRegistry = "endpoint:containerRegistry";
    export const AzureRmEndpoint = "endpoint:azureRm";
    export const Boolean = "boolean";
    export const DataSourcePickList = "dataSourcePicklist";
    export const KubernetesResource = "environmentResource:kubernetes";
    export const PickList = "picklist";
    export const String = "string";
    export const MarkDown = "markdown";
}

export namespace TemplateAssetTypes {
    export const File = "file";
}

export namespace WellKnownExceptions {
    export const DefinitionTypeNotSupportedException = "DefinitionTypeNotSupportedException";
    export const GitRepositoryNotFoundException = "GitRepositoryNotFoundException";
    export const ServiceEndpointNotFoundException = "ServiceEndpointNotFoundException";
}

export namespace WizardStateKeys {
    export const ConnectionId = "connectionId";
    export const RepositoryId = "repositoryId";
}